<div class="admin-panel">
	<section [formGroup]="form" #content>
		<mat-form-field appearance="outline">
			<mat-label translate="common_name"></mat-label>
			<input matInput formControlName="accountName" (blur)="saveAccountName()" />
			<mat-error
				*ngIf="form.controls.accountName.hasError('required')"
				translate="admin-panel_account-required">
			</mat-error>
		</mat-form-field>
		<ng-container *ngIf="useTypes$ | async as useTypes">
			<mat-form-field appearance="outline">
				<mat-label translate="group-settings_use-type"></mat-label>
				<mat-select
					formControlName="useType"
					[placeholder]="'account-setup_select_one_placeholder' | translate"
					(selectionChange)="updateUseType()"
					disableOptionCentering
					panelClass="offsetPanel">
					<mat-optgroup *ngFor="let group of useTypes" [label]="group.name">
						<mat-option
							*ngFor="let type of group.types; trackBy:'use_type_id'|trackByProp"
							[value]="type">
							{{ $any(type).name }}
						</mat-option>
					</mat-optgroup>
				</mat-select>
				<span class="dropdown-arrow"><i class="ficon-app-chevron-down"></i></span>
				<mat-error
					*ngIf="form.controls.useType.hasError('required')"
					translate="account-setup-error-required-primary-use"
					data-cy="account-create-form-course-type-required">
				</mat-error>
			</mat-form-field>
		</ng-container>
	</section>
	<mat-label class="org-label" translate="group-settings_org"></mat-label>
	<ng-select [items]="orgs$ | async"
		bindLabel="name"
		[clearable]="false"
		[loading]="orgsLoading$ | async"
		[virtualScroll]="true"
		[(ngModel)]="selectedOrg">
		<ng-template ng-label-tmp let-item="item">
			{{ item.name }} ({{item.group_id}})
		</ng-template>
		<ng-template ng-option-tmp let-item="item">
			{{ item.name }} ({{item.group_id}})
		</ng-template>
	</ng-select>
	<button type="button" *ngIf="selectedOrg && selectedOrg.group_id !== selectedService.getAccount().org_id" class="move-btn primary-btn" (click)="moveAccount()" translate="common_move"></button>
	<div class="form-group credit-ledger-form-group">
		<button
			class="secondary-btn credit-ledger-btn"
			[disabled]="!selectedService.getAccount().billing_entity_id"
			(click)="openCreditLedger()"
			translate="group-settings_view-credit-ledger">
		</button>
	</div>
</div>
